import type { TSerializedWidget } from 'src/entities/workspace/types';
import { toUnixTime } from 'src/packages/shared/utils/toUnixTime';
import { DateRangeFieldEntity } from 'src/pages/dashboard/features/controls/entities/DateRangeField.entity';
import { FilterMultiCombobox } from 'src/pages/dashboard/features/controls/entities/FilterMultiCombobox.entity';
import type { FilterWidgetEntity } from 'src/pages/dashboard/features/filter-widget/FilterWidget.entity';

export function serializeWellsFilter(widget: FilterWidgetEntity): TSerializedWidget {
  const listWidgetInternalState: {
    name: string;
    value: string | number | (number | string)[];
  }[] = [];

  for (const item of widget.items) {
    if (item instanceof FilterMultiCombobox) {
      listWidgetInternalState.push({
        name: item.attrName,
        value: item.value,
      });
    }

    if (item instanceof DateRangeFieldEntity) {
      if (item.startDate) {
        listWidgetInternalState.push({
          name: item.attrNames.startDate,
          value: toUnixTime(item.startDate),
        });
      }

      if (item.endDate) {
        listWidgetInternalState.push({
          name: item.attrNames.endDate,
          value: toUnixTime(item.endDate),
        });
      }
    }
  }

  return {
    isPinned: widget.isPinned,
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    isFullscreen: widget.isFullscreen,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    internalState: {
      isEditMode: widget.isEditMode,
      state: widget.state,
      initialState: listWidgetInternalState.map((stateItem) => ({
        name: stateItem.name,
        value: Array.isArray(stateItem.value) ? stateItem.value.map((val) => val) : stateItem.value,
      })),
    },
  };
}
